import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { Box, Modal, ModalContext, Text } from 'dash-ui';
import { AccountStatusesEnum } from 'dash-common';

import { OrganizationUsersModalsEnum } from 'pages/OrganizationPage/OrganizationDetailsPage/components/OrganizationDetailsTabs/components/OrganizationUsers/constants/constants';
import {
  GetOrganizationUsersByOrganizationRoleDocument,
  useSetOrganizationUserStatusMutation,
} from 'gql/generated.graphql';

function SetOrganizationUserStatusModal() {
  const { isOpenCurrent, toggleModal, setPayload, payload } =
    useContext(ModalContext);
  const isOpen =
    isOpenCurrent[OrganizationUsersModalsEnum.SET_ORGANIZATION_USER_STATUS] ||
    false;
  const { t } = useTranslation('pages', { keyPrefix: 'organizationUsers' });
  const { t: tCommon } = useTranslation('common');
  const theme = useTheme();
  const { organizationUserId, status } = payload || {};

  const isArchiveAction = status === AccountStatusesEnum.ARCHIVED;

  const [setOrganizationUserStatus, { loading }] =
    useSetOrganizationUserStatusMutation({
      refetchQueries: [GetOrganizationUsersByOrganizationRoleDocument],
    });

  const onCloseModal = () => {
    toggleModal(
      false,
      OrganizationUsersModalsEnum.SET_ORGANIZATION_USER_STATUS
    );
    setPayload(undefined);
  };

  const onSubmitModal = () => {
    setOrganizationUserStatus({
      variables: {
        organizationUserId: organizationUserId,
        status: status,
      },
    }).then(() => {
      onCloseModal();
    });
  };

  return (
    <Modal
      title={
        (isArchiveAction
          ? t('archiveUserModalTitle')
          : t('unarchiveUserModalTitle')) || ''
      }
      isOpen={isOpen}
      submitButton={{
        title: tCommon('labels.submit'),
        onClick: onSubmitModal,
        isLoading: loading,
      }}
      cancelButton={{
        title: tCommon('labels.cancel'),
        onClick: onCloseModal,
      }}
      onRequestClose={onCloseModal}
    >
      <Box py={3}>
        <Text color={theme.colors.n80}>
          {isArchiveAction
            ? t('archiveUserModalSubtitle')
            : t('unarchiveUserModalSubtitle')}
        </Text>
      </Box>
    </Modal>
  );
}

export default SetOrganizationUserStatusModal;
